// src/pages/Cookies.tsx
import { SeoHead } from '@/components/SeoHead';
import { LegalPageLayout } from '@/components/LegalPageLayout';
import { useLanguage } from '@/hooks/useLanguage';
import { localePath } from '@/i18n/paths';
import { cookiePolicy } from '@/lib/legal-content';

const seoContent = {
  pl: {
    title: 'Polityka Cookies | Bookeper AI',
    description:
      'Polityka cookies Bookeper AI. Dowiedz się, jak używamy plików cookie i jak możesz nimi zarządzać.',
  },
  en: {
    title: 'Cookie Policy | Bookeper AI',
    description: 'Bookeper AI Cookie Policy. Learn how we use cookies and how you can manage them.',
  },
  uk: {
    title: 'Політика Cookies | Bookeper AI',
    description:
      'Політика cookies Bookeper AI. Дізнайтеся, як ми використовуємо файли cookie та як ви можете ними керувати.',
  },
} as const;

export default function Cookies() {
  const lang = useLanguage();
  const seo = seoContent[lang];

  return (
    <>
      <SeoHead>
        <html lang={lang} />
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://www.bookeper.pl${localePath('/cookies', lang)}`} />
      </SeoHead>
      <LegalPageLayout document={cookiePolicy[lang]} />
    </>
  );
}
